import { typeIdOfChannel } from './channels';

const asString = (value) => (typeof value === 'string' ? value : '');

export const parseChatPush = (data, notification) => {
	if (!data || typeof data !== 'object') {
		return null;
	}
	const notificationType = parseInt(asString(data.notificationType), 10);
	const typeId = typeIdOfChannel(asString(data.channelName));
	const chatId = asString(data.docId);
	const key = asString(data.key);
	if (Number.isNaN(notificationType) || typeId == null || (!chatId && !key)) {
		return null;
	}
	return {
		closed: notificationType !== 0,
		typeId,
		chatId: chatId || null,
		key: key || null,
		title: asString(notification?.title),
		body: asString(notification?.body) || asString(data.body),
	};
};
